export const defaultStyle = {
  accordianContainer: "ourPositionWrapper px-[15px] lg:px-0 ",
  accordianContentWrap: " w-full xl:max-w-xl lg:max-w-lg mx-auto px-15",
  accordianContentWrapDiv: "letterWrapper flex flex-row flex-wrap",
  accordianListWrapper: "",
  accordianWrapper: "transition-all duration-1000 overflow-hidden",
  accordianList: "relative",
  accordianListActive:
    " accordianListActive hover:bg-lightpurple hover:text-white px-[32px] py-[17px] text-darkgray text-[18px] md:text-[30px] font-Light tracking-[0.75px] w-full text-left border-active text-darkgray border-lightpurple text-lightpurple border-1 font-light",
  accordianListInactive:
    "px-[32px] py-[17px] text-darkgray text-[18px] md:text-[30px] font-Light tracking-[0.75px] w-full text-left AccordianTitle relative border-1 border-darkgray hover:bg-lightpurple hover:border-lightpurple hover:text-white duration-500 mb-[35px]",
  accordianHeading:
    "heading3 text-left text-black font-MDLZBiteType tracking-[1.2px] font-normal text-60 pb-[4.5%] uppercase",
  accordianBtn: "relative flex items-center",
  accordianIconMinus:
    "absolute top-[16px] right-0 w-[40px] h-[40px] accordianIconMinus",
  accordianIconPlus:
    "absolute top-[16px] right-0 w-[40px] h-[40px] accordianIconPlus",
  accordianWrapperContent: "relative lg:static pt-[20px] ",
  accordianContent: "bodyRegular px-[35px] md:px-0 pt-[50px] text-charcoalGrey lg:w-[100%] text-[14px] md:text-[21px] font-regular [&>div>p>a]:font-bold",
  accordianCameo1: "absolute left-[-16%] top-[44%] hidden lg:block",
  accordianCameo2:
    "absolute right-[15%] bottom-[0] hidden lg:block lg:right-[-11%] lg:bottom-[22%]",
  accordianCameo3: "absolute right-[-14%] bottom-[19%] hidden lg:block",
  textLink: "linkText bg-white table text-center text-[14px] lg:text-[21px] transition-all leading-[21px] duration-[.5s] tracking-[2.4px] lg:tracking-[4.2px] uppercase border-[2px] border-purple text-purple hover:bg-lightpurple hover:border-lightpurple- hover:text-white font-Bold px-[45px] py-[20px] rounded-[40px] mx-auto my-[35px] lg:my-[45px] md:text-[21px]",
}

export const YEAR_ACCORDION = {
  ...defaultStyle,
  accordianContentWrap:
    "accordianContentWrap w-full xl:max-w-xl lg:max-w-lg mx-auto md:px-[15px]",
  accordianContainer: "ourPositionWrapper md:px-[15px] lg:px-0 ",
  accordianBtn: "accordianBtn",
  accordianIconMinus:
    "accordianIconMinus absolute top-[15px] right-0 w-[40px] h-[40px]",
  accordianIconPlus: "accordianIconPlus absolute top-[15px] right-0 w-[40px] h-[40px]",
  accordianContent: "bodyRegular text-charcoalGrey lg:w-[100%] pt-[50px] px-[35px] md:px-[0px] [&>div>p>a]:text-purple hover:[&>div>p>a]:underline [&>div>p]:mb-[16px] [&>div>p>a]:font-bold [&>div>p>a]:tracking-[2.2px]",
  accordianListActive:
    "accordianListActive hover:bg-lightpurple hover:text-white px-[32px] py-[17px] text-darkgray text-[18px] md:text-[30px] font-Light tracking-[0.75px] w-full text-left border-active text-darkgray border-lightpurple text-lightpurple border-1 font-light",
  accordianListInactive:
    "px-[32px] py-[17px] text-darkgray text-[18px] md:text-[30px] font-Light tracking-[0.75px] w-full text-left AccordianTitle relative border-1 border-darkgray hover:bg-lightpurple hover:border-lightpurple hover:text-white duration-500 mb-[35px]",
  textLink: "linkText",
  accordianList: "relative mb-[0px] md:mb-[50px]",
  accordianWrapper: "accordianWrapper transition-all duration-1000 overflow-hidden",
}

export const TABBING_WITH_LANG = {
  accordianListActive:
    "accordianListActive px-[32px] py-[17px] text-[21px] font-Regular text-left",
  accordianIconPlus:
    "absolute top-[16px] right-0 w-[40px] h-[40px]",
  accordianListInactive:
    "px-[32px] py-[17px] text-[21px] text-left font-Regular flex items-center",
  accordianIconMinus:
    "accordianUp",
  accordianIconPlus: "accordianDown",
}

export const ITALY_ACCORDION = {
  ...defaultStyle,
  accordianListActive: "badgeHeading text-left font-[300] text-[24px] lg:text-[48px] text-green mb-[20px] md:mb-[35px] leading-[1.2] lg:leading-[57px] tracking-normal font-Light",
  accordianListInactive: "badgeHeading text-left font-[300] text-[24px] lg:text-[48px] text-green  mb-[20px] md:mb-[35px] leading-[1.2] lg:leading-[57px] tracking-normal font-Light",
  accordianIconMinus: "",
  accordianIconPlus: "",
  accordianWrapperContent: "relative lg:static",
  accordianContent: "bodyRegular text-charcoalGrey lg:w-[100%] text-[14px] md:text-[21px] font-regular [&>div>p>a]:font-bold",
}


export const TREND_RADAR_CHART = {
  accordianContainer:"max-width-wrapper mb-40 px-35 md:p-15 font-BwSurco",
  accordianContentWrap:"lg:flex lg:gap-y-10 lg:justify-between",
  accordionGroupWrapper:"lg:w-[47%]",
  accordionTitle: `font-BwSurcoBold text-18 leading-[1.333] text-left w-full flex justify-between items-center gap-x-10
                  lg:!pointer-events-none outline-none scroll-mt-15`,
  accordianListActive: "lg:flex lg:gap-y-10",
  accordianHeading: "accordianHeading font-BwSurcoBold text-24 font-bold leading-[1.333] text-purple text-center uppercase mb-16 lg:mb-0",
  accordionGroupImage:"mx-auto border-1 border-transparent",
  accordionGroupDescription:"accordionGroupDescription flex flex-col gap-y-10 my-10",
  accordianListWrapper:"mt-16",
  accordianBtn: "py-15 first:last:pb-0 border-t border-gray250 last:border-b first:!border-b-0 lg:border-none",
  accordianIconMinus: " accordianIconMinus lg:hidden",
  accordianIconPlus: " accordianIconPlus lg:hidden",
  accordianWrapper: "grid grid-rows-[0fr] transition-all duration-700 overflow-hidden lg:!h-auto lg:!opacity-100",
  accordianWrapperContent: "text-16 leading-[1.2] description overflow-hidden",
  activeAccordianWrapper: "grid-rows-[1fr] pt-10",
  shortDescription:" lg:block hidden",
  accordionItemImages:"hidden",
  textLink:`mt-40 bg-purple text-16 lg:text-18 leading-none text-white text-center py-12 lg:py-20 px-24 rounded-[100px] flex items-center gap-x-4 w-fit
  after:inline-block after:content-[""] after:bg-downloadIcon2 after:w-[20px] after:h-[20px] after:bg-no-repeat after:bg-center`
}

export const TREND_RADAR_CHART_MOBILE_SCREEN_ACCORDION = {
  ...TREND_RADAR_CHART,
  accordianContainer:"w-full mb-40 px-22 font-BwSurco",
  accordionImgActive: "!border-gray250",
  endNotesAccordionItem:"mt-25 scroll-mt-20",
}